import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getActiveTab, getEditedJob, getResultQuery, selectAll } from '../../store/selectors'
import { resultActions, uiActions } from '../../store/slices'

import { Tabs } from '../../../../components'
import { JobTally, Result } from './components'
import { OUTPUT_TAB } from '../../common/constants'
import { isEmpty, isNull } from '../../../../utils/fns'

const Output = (props) => {
  const dispatch = useDispatch()
  const activeTab = useSelector(getActiveTab)
  const editedJob = useSelector(getEditedJob)
  const jobs = useSelector(selectAll)
  const query = useSelector(getResultQuery)

  useEffect(() => {
    let promise
    if (query) {
      promise = dispatch(resultActions.getHangersData(query))
    }
    return () => {
      if (promise) {
        promise.abort()
      }
    }
  }, [query])

  const handleChangeTab = (tab) => dispatch(uiActions.setActiveTab(tab))
  return (
    <div className="outputSectionWrapper" {...props}>
      <Tabs activeTab={activeTab} setActiveTab={handleChangeTab} className="paneHeader">
        <div
          // TODO: Create Tab.Header
          // eslint-disable-next-line react/no-unknown-property
          eventKey={OUTPUT_TAB.RESULT}
          title={<div className="paneHeader__staticHeading">Output</div>}
          className="outputSection hangerSelectorOutput"
        >
          <div className="container-fluid space-y-12">
            <Result />
          </div>
        </div>
        <div
          id="jobTally__tab"
          // eslint-disable-next-line react/no-unknown-property
          eventKey={OUTPUT_TAB.JOB_TALLY}
          title={
            <div className="paneHeader__staticHeading">
              {editedJob
                ? `Editing ${editedJob.uid}`
                : `Job List${jobs.length > 0 ? ` (${jobs.length})` : ''}`}
            </div>
          }
          disabled={!isNull(editedJob) || isEmpty(jobs)}
          className="outputSection hangerSelectorOutput"
        >
          <div className="container-fluid space-y-12">
            <JobTally />
          </div>
        </div>
      </Tabs>
    </div>
  )
}

export default Output
